import React, { Component } from "react";
import "survey-react/survey.css";
import * as Survey from "survey-react";

import { connect } from "react-redux";
import { getSingleSurveyThunk } from "../redux/survey/survey.thunk";
// Here you import your custom AuthKit

import { Link } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "../azure_auth/AuthKit";
import ErrorBoundary from "../azure_auth/ErrorBoundary";

class DisplaySurvey extends Component {
  state = {
    json: undefined,
    loaded: false
  };

  async componentDidMount() {
    const path = window.location.pathname.split("/");
    const id = path[path.length - 1];
    await this.props.getSingleSurvey(id);
    this.setState({ json: this.props.singleSurvey.json, loaded: true });
  }

  render() {
    const { json, loaded } = this.state;

    return (
      <ErrorBoundary sectionName="DisplaySurvey">
        <AuthenticatedTemplate>
          <div className="py-3 text-end">
            <Link to="/surveys" style={{ textDecoration: "none" }}>
              <Button variant="contained">Back</Button>
            </Link>
          </div>

          {!loaded || json === undefined ? (
            <div className="text-center">
              <CircularProgress />
            </div>
          ) : (
            <Survey.Survey
              json={json}
              showNavigationButtons={false}
              mode="display"
            />
          )}
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <div style={{ padding: 20, textAlign: "center" }}>
            <h3>Please Sign In to View the Survey</h3>
          </div>
        </UnauthenticatedTemplate>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state) => ({
  singleSurvey: state.surveys.singleSurvey
});

const mapDispatchToProps = (dispatch) => ({
  getSingleSurvey: (id) => dispatch(getSingleSurveyThunk(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(DisplaySurvey);
